// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Logo/Logo.scss
// module id = 115
// module chunks = 0